import Axios from '../../utils/axios';
import { getBackendErrorMessage } from '../../utils/errorHandler';

export interface Driver {
  id: number;
  ID?: number;
  name: string;
  first_name: string;
  last_name: string;
  code?: string;
  nik?: string;
  status?: string;
  email?: string;
  phone?: string;
  phone_number?: string;
  city?: {
    id?: number | string;
    name?: string;
  };
  active?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface DriverListResponse {
  data: Driver[];
  pagination?: {
    total: number;
    page: number;
    size: number;
    lastPage: number;
  };
}

export const getListDrivers = async (params: {
  active?: string;
  page?: string;
  size?: string;
  search?: string;
  sort?: string;
  order?: string;
  status?: string;
  handoverStates?: string;
  cityIds?: string;
}): Promise<DriverListResponse> => {
  try {
    const response = await Axios.get('/v3/drivers', { params });
    return response.data;
  } catch (error) {
    throw new Error(getBackendErrorMessage(error));
  }
};
